/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DiscreteNumericValueDto } from './DiscreteNumericValueDto';
import {
    DiscreteNumericValueDtoFromJSON,
    DiscreteNumericValueDtoFromJSONTyped,
    DiscreteNumericValueDtoToJSON,
} from './DiscreteNumericValueDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';

/**
 * 
 * @export
 * @interface ElectronBeamQualityCombinationValueDto
 */
export interface ElectronBeamQualityCombinationValueDto {
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    beamQualityName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    beamQualityId?: string;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {DiscreteNumericValueDto}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    selectedDoseRate?: DiscreteNumericValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    radiationType?: EnumerationValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    energy?: NumericValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    highDoseTechniqueType?: EnumerationValueDto;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityCombinationValueDto
     */
    $type?: ElectronBeamQualityCombinationValueDtoTypeEnum;
}


/**
 * @export
 */
export const ElectronBeamQualityCombinationValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoParameterCombinationsElectronBeamQualityCombinationValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.ElectronBeamQualityCombinationValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ElectronBeamQualityCombinationValueDtoTypeEnum = typeof ElectronBeamQualityCombinationValueDtoTypeEnum[keyof typeof ElectronBeamQualityCombinationValueDtoTypeEnum];



/**
 * Check if a given object implements the ElectronBeamQualityCombinationValueDto interface.
 */
export function instanceOfElectronBeamQualityCombinationValueDto(value?: unknown): value is ElectronBeamQualityCombinationValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ElectronBeamQualityCombinationValueDtoTypeEnum)[0];
}

export function ElectronBeamQualityCombinationValueDtoFromJSON(json: any): ElectronBeamQualityCombinationValueDto {
    return ElectronBeamQualityCombinationValueDtoFromJSONTyped(json, false);
}

export function ElectronBeamQualityCombinationValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElectronBeamQualityCombinationValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'beamQualityName': json['beamQualityName'] == null ? undefined : json['beamQualityName'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupHash': json['groupHash'] == null ? undefined : json['groupHash'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'beamQualityId': json['beamQualityId'] == null ? undefined : json['beamQualityId'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'selectedDoseRate': json['selectedDoseRate'] == null ? undefined : DiscreteNumericValueDtoFromJSON(json['selectedDoseRate']),
        'radiationType': json['radiationType'] == null ? undefined : EnumerationValueDtoFromJSON(json['radiationType']),
        'energy': json['energy'] == null ? undefined : NumericValueDtoFromJSON(json['energy']),
        'highDoseTechniqueType': json['highDoseTechniqueType'] == null ? undefined : EnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ElectronBeamQualityCombinationValueDtoToJSON(value?: ElectronBeamQualityCombinationValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'beamQualityName': value['beamQualityName'],
        'groupName': value['groupName'],
        'groupHash': value['groupHash'],
        'groupId': value['groupId'],
        'beamQualityId': value['beamQualityId'],
        'origin': EntityOriginToJSON(value['origin']),
        'selectedDoseRate': DiscreteNumericValueDtoToJSON(value['selectedDoseRate']),
        'radiationType': EnumerationValueDtoToJSON(value['radiationType']),
        'energy': NumericValueDtoToJSON(value['energy']),
        'highDoseTechniqueType': EnumerationValueDtoToJSON(value['highDoseTechniqueType']),
        '$type': value['$type'],
    });
}

